import { Banner, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { urlBuilder } from '../../Shared/urlBuilder';

export const Pre2024ActivityBanner: React.FC = () => {
  return (
    <Banner variant="info">
      <Banner.Content>
        <Text as="p">
          Transactions before January 2024 are not available here. Please navigate to{' '}
          <SambaAutoLink to={urlBuilder.getDocuments.absolute()}>Statements</SambaAutoLink> to view these transactions.
        </Text>
      </Banner.Content>
    </Banner>
  );
};
